// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 453 ? "eef9e134" : chunkId) + "." + {"29":"69003fb152d4c506","361":"b976a827250dd017","391":"e99bb75ed0e58e9c","413":"f869526c7f021ee4","453":"6a55016045eb10e9","524":"55c910924d5b46f8","708":"bb97aa98824f0002"}[chunkId] + ".js";
};